import BaseApi from '../base'

const basePath = '/invoicing/sale'
export default class SaleApi extends BaseApi {
  constructor() {
    super(basePath)
  }
  static GetInstance = () => new SaleApi()
  getApprovePage = params => this.get(`${basePath}/approve-page`, params)
  getStat = params => this.get(`${basePath}/stat`, params)
  getOrder = id => this.get(`invoicing/storage-manage-record/order/${id}`)
  // 获取用户销售单列表
  getSalesList = (year, userId) => this.get(`${basePath}/list/${year}/${userId}`)
  // 销售报表
  getReport = params => this.get(`${basePath}/report`, params)
  // 修改商城销售单状态
  updateMallOrderStatus = params => this.put(`${basePath}/mall/update-status`, params)
  // 资金占用统计
  getFinanceCostStat = year => this.get(`${basePath}/stat/finance-cost/${year}`)
  // 月绩效
  getPerformanceReport = () => this.get(`${basePath}/stat/performance`)
  // 批量获取详情
  getByIds = params => this.get(`${basePath}/get-by-ids`, params)
}
